export const tagsConfig = {
    activity: {
        cyberMonday: {
            text: 'web_tag_cyber_monday'
        },
        blackFriday: {
            text: 'web_tag_black_friday'
        }
    },
    product: {
        superflashsale: {
            icon: 'icon-a-flashsale',
            text: 'web_tag_super_flash_sale'
        },
        wholesale: {
            icon: 'icon-wholesale',
            text: 'web_tag_wholesale'
        },
        flashsale: {
            icon: 'icon-a-flashsale',
            text: 'web_tag_off'
        },
        newarrival: {
            icon: 'icon-new',
            text: 'web_tag_new'
        },
        bestseller: {
            icon: 'icon-star-integrity',
            text: 'web_tag_best_seller'
        },
        presale: {
            icon: 'icon-a-Presale',
            text: 'web_tag_pre_sale'
        },
    }
}